/**
 * Business Loan SE Insert Service
 * Migrated from 3in1cms bajajfinserv-web/ui.solid/src/lib/connectionManager/blseInsertApi.ts
 */

import { logPageActionToNewRelic } from "@repo/shared-utils/newRelic-log-utils";
import { getLoginState, commonInsertParameters } from "@repo/shared-utils/insert-params";
import { request } from "../core/request";
import { deleteFromCartApi } from "./cart.service";
import {
  API_RESPONSE_CODES,
  BLSE_SME_EVENT_CODE,
  OPERATION_IDS,
  SME_EVENT_NAME,
} from "./constants";
import { COMMON_SSO_ACCESS_TOKEN } from "../constants/sso";
import type {
  IBlseInsertConnectionManagerRequest,
  IBlseInsertConnectionManagerResponse,
} from "../types/blseInsertTypes";

export const blseInsert = async (
  data: IBlseInsertConnectionManagerRequest
): Promise<IBlseInsertConnectionManagerResponse> => {
  data.offerId = data.offerId ?? "";
  data.offerName = data.offerName ?? "";

  try {
    if (data.mobileNo && data.appId) {
      await deleteFromCartApi({
        mobileNo: data.mobileNo,
        appId: data.appId,
        channel: "3in1",
      }).catch((deleteError: Error) => {
        logPageActionToNewRelic("BLSE_DELETE_CART_ERROR", {
          component: "BLSE Insert",
          pageUrl: typeof window !== "undefined" ? window.location.href : "",
          message: deleteError.message,
          debugInfo: JSON.stringify({
            loginState: getLoginState(),
            hasAToken:
              typeof window !== "undefined" && !!localStorage.getItem(COMMON_SSO_ACCESS_TOKEN),
            hasMobile: !!data.mobileNo,
          }),
        });
      });
    }

    const response = await request<IBlseInsertConnectionManagerResponse & { statusCode?: string }>({
      operationId: OPERATION_IDS.blseInsert,
      requestData: {
        ...commonInsertParameters({
          appDtls: {
            custId: data.custId,
            profession: data.profession,
            subProfession: data.subProfession,
            custType: "Individual",
          },
        }),
        eventCode: BLSE_SME_EVENT_CODE,
        eventName: SME_EVENT_NAME,
        ...data,
      },
    });

    if (response.statusCode !== API_RESPONSE_CODES.STATUS_CODE_7001) {
      throw new Error(JSON.stringify(response));
    }
    return response;
  } catch (error) {
    logPageActionToNewRelic("BLSE_INSERT_ERROR", {
      component: "BLSE Insert",
      pageUrl: typeof window !== "undefined" ? window.location.href : "",
      message: (error as Error).message,
      debugInfo: JSON.stringify({
        loginState: getLoginState(),
        hasAToken: typeof window !== "undefined" && !!localStorage.getItem(COMMON_SSO_ACCESS_TOKEN),
        hasMobile: !!data.mobileNo,
      }),
    });
    throw error;
  }
};
